import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { ToolBar } from '@1c/ui';
import { useNavigate } from 'src/utils/useNavigate';
import { FinalField, FinalForm } from 'src/components/FinalForm';
import Button from 'src/components/Button';
import InputField from 'src/components/InputField';
import { postSetPasswordAPI } from 'src/serverApi/account';
import routes from 'src/constants/routes';
import styles from './styles.module.scss';
import validate from './validate';

const Form: React.FC = () => {
  const navigate = useNavigate();
  
  const [isLoading, setIsLoading] = useState(false);
  
  const setPassword = async (data: any) => {
    try {
      setIsLoading(true);
      await postSetPasswordAPI(data);
      navigate(routes.accountProfile);
      toast.success('Пароль успешно изменен');
    } catch (error) {
      const { type } = error as any;
      const messages: { [key: string]: string } = {
        ['PASSWORD_FORMAT']:
          'Некорректный формат пароля. Есть пустые смволы в начале и/или в конце.',
        ['PASSWORD_IS_NOT_STRONG']: 'Пароль недостаточно сложный (менее 8 символов).',
      };
      toast.error(messages[type] || 'Произошла ошибка. Попробуйте позже.');
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleBack = () => {
    navigate(routes.accountProfile);
  }
  
  const handleSubmit = (values: any) => {
    setPassword(values?.password);
  };
  
  return (
  
    <FinalForm
      onSubmit={handleSubmit}
      submitting={isLoading}
      pristine
      initialValues={{ password: undefined, confirmPassword: undefined }}
      validate={validate}
    >
      {({ submitting, pristine }: { submitting: any; pristine: any }) => {
        return (
          <div className={styles['form']}>
            <FinalField name="password">
              {({ onChange }: { onChange: any }) => (
                <InputField
                  type="password"
                  label="Пароль"
                  onChange={onChange}
                  className={styles['input']}
                />
              )}
            </FinalField>
            <FinalField name="confirmPassword">
              {({ onChange, error }: { onChange: any; error: string }) => (
                <InputField
                  type="password"
                  label="Повторите пароль"
                  onChange={onChange}
                  className={styles['input']}
                  error={error}
                />
              )}
            </FinalField>
            <ToolBar align="center" className={styles['buttons']}>
              <Button variant="text" disabled={submitting} onClick={handleBack}>
                Назад
              </Button>
              <Button disabled={submitting || pristine} type="submit">
                Сохранить
              </Button>
            </ToolBar>
          </div>
        );
      }}
    </FinalForm>
  );
};

export default Form;
